/**
 * Post-fetch guards are a final pass over selector results after API filters run.
 *
 * Use this for compatibility rules that cannot be expressed reliably as query params,
 * for example rules that need runtime Studio context (slot/object graph) or local
 * metadata enrichment when API payloads are missing required compatibility fields.
 *
 * Keep `HardwareSelectorCore` generic by adding domain-specific guards in
 * `./guards/*` and appending them to `DOMAIN_POST_FETCH_GUARDS` below.
 */
import { runPostFetchGuards } from './core/applyPostFetchGuards'
import { acIsolatorVoltageBucketPostFetchGuard } from './guards/acIsolatorVoltageBucketPostFetchGuard'
import { dcIsolatorCompatibilityPostFetchGuard } from './guards/dcIsolatorCompatibilityPostFetchGuard'
import { solveraManualSelectionPostFetchGuard } from './guards/solveraManualSelectionPostFetchGuard'
import type { PostFetchGuardContext } from './types'

const DOMAIN_POST_FETCH_GUARDS = [
  dcIsolatorCompatibilityPostFetchGuard,
  acIsolatorVoltageBucketPostFetchGuard,
  solveraManualSelectionPostFetchGuard,
]

export const applyPostFetchGuards = (context: PostFetchGuardContext): any[] => {
  return runPostFetchGuards(context, DOMAIN_POST_FETCH_GUARDS)
}
